import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import map from "../../assets/images/map.png";

const LazyLoadedMap = () => {
    const [mapLoaded, setMapLoaded] = useState(false);

    const handleButtonClick = () => {
        setMapLoaded(true);
    };

    const center = [49.0461263, 8.5118614];
    const address = "Kanalstraße 72, 76356 Weingarten, Deutschland";

    const handleNavigate = () => {
        const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            address
        )}`;
        window.open(url, "_blank");
    };

    const customIcon = new L.Icon({
        iconUrl:
            "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
    });

    return (
        <div style={{ textAlign: "center" }} className="py-0 md:py-32">
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "900px",
                    height: "500px",
                    margin: "0 auto",
                    border: "1px solid #ccc",
                }}
                className="z-10"
            >
                {mapLoaded ? (
                    <MapContainer
                        center={center}
                        zoom={15}
                        style={{ width: "100%", height: "100%" }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                        />
                        <Marker position={center} icon={customIcon}>
                            <Popup>
                                <div>
                                    <strong>{address}</strong>
                                    <br />
                                    <button
                                        onClick={handleNavigate}
                                        style={{
                                            marginTop: "5px",
                                            padding: "5px 10px",
                                            backgroundColor: "#007BFF",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "3px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Navigation starten
                                    </button>
                                </div>
                            </Popup>
                        </Marker>
                    </MapContainer>
                ) : (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${map})`,
                        }}
                    >
                        <div className="absolute w-full h-full bg-black bg-opacity-50 z-0"></div>
                    </div>
                )}
                {!mapLoaded && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <p className="text-white font-bold text-lg">
                            Durch Klicken auf den Button wird die Karte geladen.
                            Dies integriert Inhalte von Drittanbietern
                            (OpenStreetMap).
                        </p>
                        <button
                            onClick={handleButtonClick}
                            className="bg-enedemgreen hover:bg-green-800 mt-4"
                            style={{
                                padding: "10px 20px",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Karte laden
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LazyLoadedMap;
